import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router'
import { useMediaQuery } from 'usehooks-ts'


import stylesLayout from '@pages/catalog/ui/styles.module.scss'

import { useCategorySlug } from '@entities/Categories'
import {
  ButtonProductFilters,
  ProductFilters,
  Products,
  useProductSort,
} from '@entities/Product'
import { SORT_PRODUCTS } from '@entities/Product/sort'

import { CartPreview } from '@features/cart'
import { useAddressStore } from '@features/shipping-methods'

import { CategoriesBranch } from '@widgets/categories-branch'




import { URL_PAGE_CATALOG_2ND_LVL } from '@shared/contants'
import { useCategoryQuery } from '@shared/generated'
import { cn } from '@shared/lib/cn'
import Breadcrumbs from '@shared/ui/breadcrumbs'
import Container from '@shared/ui/container'
import PageGrid from '@shared/ui/page-grid'
import SelectSort from '@shared/ui/select-sort'
import TitleWithCount from '@shared/ui/title-with-count'
import Wrapper from '@shared/ui/wrapper'
import getNoun from '@shared/uttils/getNoun'

import styles from './styles.module.scss'


export default function CategorySubChildrenCatalogPage () {
  const { t: tn } = useTranslation('navigation')
  const { t: tp } = useTranslation('product')

  const isTablet = useMediaQuery('(max-width: 991px)')
  
  const categorySlug  = useCategorySlug()
  const { shopId } = useAddressStore()
  
  const { sortKey, setSortKey } = useProductSort()
  
  const [ totalProducts, setTotalProducts ] = useState<number | null>(null)
  
  const { data: category, loading: loadingCategory } = useCategoryQuery({
    variables: {
      shopId: shopId,
      slug: categorySlug,
    }
  })

  console.log('category', category)

  const { data: parentCategory } = useCategoryQuery({
    variables: {
      shopId: shopId,
      categoryId: category?.category?.parent?.id,
    },
  })

  return (
    <Container>
      <PageGrid aside={<CartPreview />}>
        <Wrapper className={styles.wrapper}>
          <div className={stylesLayout.grid}>
            <Breadcrumbs
              className={stylesLayout.breadcrumbs}
              links={[
                {
                  title: tn('catalog'),
                  to: '/catalog',
                },
                ...(parentCategory?.category?.parent
                  ? [
                    {
                      title: parentCategory.category.parent.name as string,
                      to: `/catalog/${parentCategory.category.parent.slug}`,
                    },
                  ]
                  : []),
                ...(category?.category?.parent &&
                parentCategory?.category?.parent
                  ? [
                    {
                      title: category.category.parent.name as string,
                      to: generatePath(URL_PAGE_CATALOG_2ND_LVL, {
                        categorySlug: parentCategory.category.parent.slug as string,
                        categoryChildrenSlug: category.category.parent.slug as string,
                      }),
                    },
                  ]
                  : []),
                {
                  title: category?.category?.name as string,
                },
              ]}
              style={{
                marginBottom: '24px',
              }}
            />
            {!isTablet && (
              <div className={cn(stylesLayout.aside, styles.aside)}>
                <div className={styles.aside}>
                  <CategoriesBranch className={styles.aside__content} />
                </div>
                { category?.category?.id && <ProductFilters categoryId={category?.category?.id} /> }
              </div>
            )}

            <div className={cn(stylesLayout.content)}>
              <div className={styles.root__top}>
                {category?.category?.name && (
                  <TitleWithCount
                    className={styles.root__title}
                    title={category?.category?.name as string}
                  >
                    {totalProducts !== null && (
                      <>
                        {totalProducts}{' '}
                        {getNoun(
                          totalProducts as number,
                          tp('product.1'),
                          tp('product.2'),
                          tp('product.3'),
                        )}
                      </>
                    )}
                  </TitleWithCount>
                )}

                {isTablet && (
                  <ButtonProductFilters
                    className={styles['root__filter-button']}
                  />
                )}

                {(totalProducts === null || totalProducts > 0) && (
                  <SelectSort
                    className={styles.root__sort}
                    fields={SORT_PRODUCTS}
                    value={sortKey}
                    onChange={(key) => {
                      setSortKey(key)
                    }}
                  />
                )}
              </div>

              <Products
                categoryId={category?.category?.id}
                loadingCategory={loadingCategory}
                onTotalChange={setTotalProducts}
              />
            </div>
          </div>
        </Wrapper>
      </PageGrid>
    </Container>
  )
}
